// extracted by css-extract-rspack-plugin
export default {"plainLink":"ecp6T","inline":"qlc4d"};